// Modalita' di lavoro del wizard (vedi SPECCOUPON2026.md e SPECS_COUPON.md).
//
// Nella pagina di selezione del codice bolla l'utente precisa se sta emettendo
// un DDT oppure creando un coupon di carico. Il coupon e' l'azione di default:
// il parametro assente dall'URL vale modalita' coupon.
//
// La scelta viaggia nell'URL come modalita_coupon=true|false e viene passata
// alle funzioni ghiaia3.verifica_valori_ddt / _e_salva come modalita_coupon.

export const MODALITA_COUPON_PARAM = 'modalita_coupon';

// true = coupon (default), false = emissione DDT
export function isCouponMode(searchParams) {
    return searchParams.get(MODALITA_COUPON_PARAM) !== 'false';
}

// Valore convenzionale della tara che all'emissione del DDT viene sostituito
// con la tara registrata sul veicolo (SPECS_COUPON.md, "Gestione della tara")
export const TARA_DA_VEICOLO = 9999;
